(() => {
  if (customElements.get('aldeno-club-members')) return;
  class ClubMembers extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.cards = Array.from(this.querySelectorAll('[data-club-member]'));
      if (!this.cards.length) return;
      this.ready = true;
      this.index = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('[data-club-prev]').addEventListener('click', () => this.select(this.index - 1), options);
      this.querySelector('[data-club-next]').addEventListener('click', () => this.select(this.index + 1), options);
      this.cards.forEach((card, index) => {
        card.querySelector('[data-club-select]').addEventListener('click', () => this.select(index), options);
      });
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse') return;
        this.touchStart = { x: event.clientX, y: event.clientY };
      }, options);
      this.addEventListener('pointerup', event => {
        if (!this.touchStart) return;
        const dx = event.clientX - this.touchStart.x;
        const dy = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.select(this.index + (dx < 0 ? 1 : -1));
      }, options);
      this.addEventListener('pointercancel', () => { this.touchStart = null; }, options);
      // Horizontal trackpad scrolling advances the highlighted profile;
      // ordinary vertical scrolling remains available for the page.
      this.querySelector('.club-carousel__track').addEventListener('wheel', event => {
        const delta = event.shiftKey && !event.deltaX ? event.deltaY : event.deltaX;
        if (!event.shiftKey && Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        if (Math.abs(delta) < 5) return;
        const next = this.index + (delta > 0 ? 1 : -1);
        if (next < 0 || next >= this.cards.length) return;
        event.preventDefault();
        if (this.transitioning || Date.now() < (this.wheelUntil || 0)) return;
        this.wheelUntil = Date.now() + 650;
        this.select(next);
      }, { ...options, passive: false });
      this.classList.add('is-ready');
      this.querySelector('.club-carousel__controls').hidden = this.cards.length < 2;
      this.select(0, false);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-club-member]');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.select(index);
      }, options);
    }
    async select(index, announce = true) {
      const total = this.cards.length;
      const nextIndex = Math.max(0, Math.min(index, total - 1));
      if (this.transitioning || (announce && nextIndex === this.index)) return;
      const track = this.querySelector('.club-carousel__track');
      const previousHeight = track.getBoundingClientRect().height;
      const animate = announce && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.transitioning = true;
      if (animate) {
        this.animation = track.animate([{ opacity: 1 }, { opacity: 0 }], {
          duration: 140, easing: 'ease-out', fill: 'forwards',
        });
        try { await this.animation.finished; } catch { this.transitioning = false; return; }
        if (!this.isConnected) { this.transitioning = false; return; }
      }
      const previousFocus = document.activeElement;
      const focusedCard = this.cards.find(card => card.contains(previousFocus));
      this.index = nextIndex;
      this.querySelector('[data-club-prev]').disabled = this.index === 0;
      this.querySelector('[data-club-next]').disabled = this.index === total - 1;
      this.cards.forEach((card, i) => {
        const position = i - this.index;
        card.hidden = position < 0 || position > 2;
        card.style.order = String(position);
        card.classList.toggle('is-active', position === 0);
        card.querySelector('[data-club-select]').setAttribute('aria-pressed', String(position === 0));
      });
      if (focusedCard?.hidden) this.cards[this.index].querySelector('[data-club-select]').focus({ preventScroll: true });
      if (announce) this.querySelector('[data-club-status]').textContent = `${this.cards[this.index].getAttribute('aria-label')}, member ${this.index + 1} of ${total}`;
      if (animate) {
        this.animation.cancel();
        const nextHeight = track.getBoundingClientRect().height;
        this.animation = track.animate([
          { opacity: 0, transform: 'translateY(6px)', height: `${previousHeight}px` },
          { opacity: 1, transform: 'translateY(0)', height: `${nextHeight}px` },
        ], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' });
        try { await this.animation.finished; } catch { /* Cancelled when section is removed. */ }
      }
      this.transitioning = false;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.animation?.cancel();
      this.transitioning = false;
      this.ready = false;
    }
  }
  customElements.define('aldeno-club-members', ClubMembers);
  document.querySelectorAll('.club-join__form').forEach(form => {
    form.addEventListener('formdata', event => {
      const phone = String(event.formData.get('contact[phone]') || '').replace(/\s/g, '');
      if (/^[6-9][0-9]{9}$/.test(phone)) event.formData.set('contact[phone]', `+91${phone}`);
    });
  });
  document.querySelector('[data-club-form-message]')?.focus({ preventScroll: true });
})();
